import { BellRing, LogOut, MonitorSmartphone, MoonStar, ShieldCheck, UserRound } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Clock3 } from "lucide-react";

import { CustomerGate } from "../../components/AuthGate";
import { Avatar } from "../../components/Avatar";
import { InstallPrompt } from "../../components/InstallPrompt";
import { PushControl } from "../../components/PushControl";
import { TimezonePreference } from "../../components/TimezonePreference";
import { useSession } from "../../context/SessionContext";
import { useTheme } from "../../context/ThemeContext";

function CustomerProfile() {
  const { user, logout, config } = useSession();
  const { preference, setPreference } = useTheme();
  const navigate = useNavigate();
  const [signingOut, setSigningOut] = useState(false);

  async function signOut() {
    if (signingOut) return;
    setSigningOut(true);
    try {
      await logout();
      navigate("/", { replace: true });
    } catch {
      // The session provider displays the error; keep the current profile visible.
    } finally {
      setSigningOut(false);
    }
  }

  return (
    <section className="page-stack profile-page">
      <header className="page-header"><div><p className="eyebrow">Your account</p><h1>Profile & notifications</h1><p>Support uses the same identity as your Next-Cart account.</p></div></header>
      <div className="profile-grid">
        <section className="card profile-summary">
          <Avatar name={user?.name ?? "Customer"} url={user?.avatarUrl} size="large" />
          <div><h2>{user?.name}</h2><p>{user?.email}</p><span className="profile-summary__connection"><ShieldCheck aria-hidden="true" size={14} /> Connected with Next-Cart SSO</span></div>
        </section>
        <section className="card settings-card">
          <header><span><BellRing aria-hidden="true" /></span><div><h2>Push notifications</h2><p>Get ticket replies on this device, even when support is closed.</p></div></header>
          <PushControl />
        </section>
        <section className="card settings-card">
          <header><span><MoonStar aria-hidden="true" /></span><div><h2>Appearance</h2><p>Choose a theme for this device.</p></div></header>
          <label className="field field--inline"><span className="sr-only">Theme</span><select value={preference} onChange={(event) => setPreference(event.target.value as "light" | "dark" | "system")}><option value="system">Use device setting</option><option value="light">Light</option><option value="dark">Dark</option></select></label>
        </section>
        <section className="card settings-card">
          <header><span><Clock3 aria-hidden="true" /></span><div><h2>Timezone</h2><p>Dates and times in Support use this timezone. The default is UTC.</p></div></header>
          <TimezonePreference />
        </section>
        <section className="card settings-card">
          <header><span><MonitorSmartphone aria-hidden="true" /></span><div><h2>Add Support to this device</h2><p>Save the Support web app for quick access. It is installed from your browser, not an app store.</p></div></header>
          <InstallPrompt compact />
        </section>
      </div>
      <section className="card account-actions"><div><UserRound aria-hidden="true" /><span><strong>Manage your main account</strong><small>Profile details are managed in Next-Cart Dash.</small></span></div><a className="button button--secondary" href={config.dashUrl || "https://dash.next-cart.com"} target="_blank" rel="noreferrer">Open Dash</a></section>
      <button className="button button--danger profile-logout" type="button" disabled={signingOut} onClick={signOut}><LogOut aria-hidden="true" size={17} /> {signingOut ? "Signing out…" : "Sign out of support"}</button>
    </section>
  );
}

export function ProfilePage() {
  return <CustomerGate><CustomerProfile /></CustomerGate>;
}
